import { FC, memo } from 'react'

import { useForm, useStore } from '@tanstack/react-form'
import { getRouteApi } from '@tanstack/react-router'
import { omitBy } from 'lodash'
import { DatePicker, FF, Select } from 'ui/components'
import { IntegerInput, TextInput } from 'ui/components/InputV2'
import { FilterPanel } from 'ui/components/Table'

import { s } from './styles'

const routeApi = getRouteApi('/_app/bsa/ctr-batch-list')

export const Filter: FC = memo(() => {
  const navigate = routeApi.useNavigate()

  const statusOptions = routeApi.useLoaderData({
    select: (s) => s.statusOptions
  })

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { page: _, size, ...searchParams } = routeApi.useSearch({ select: (s) => s })

  const form = useForm({
    defaultValues: searchParams,
    validators: {
      onChangeAsync: ({ value }) => {
        navigate({
          search: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            page: 1,
            size,
            ...omitBy(value, (v) => !v)
          },
          resetScroll: false
        })

        return undefined
      }
    }
  })

  const reset = () => {
    form.reset()
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    navigate({ search: (search) => ({ page: search.page, size: search.size }), resetScroll: false })
  }

  return (
    <FilterPanel isDirty={useStore(form.store, (s) => s.isDirty)} onReset={reset}>
      <s.FormWrapper>
        <s.Row>
          <s.LeftWrapper>
            <form.Field
              name="batchId"
              children={(idField) => (
                <FF field={idField} label="Batch ID" input={(inputProps) => <IntegerInput {...inputProps} />} />
              )}
            />
            <form.Field
              name="bsaTrackingId"
              children={(trackingField) => (
                <FF
                  field={trackingField}
                  label="BSA Tracking ID"
                  input={(inputProps) => <TextInput {...inputProps} />}
                />
              )}
            />
          </s.LeftWrapper>
          <s.RightWrapper>
            <form.Field
              name="date"
              children={(dateField) => (
                <FF label="Date" field={dateField} input={(inputProps) => <DatePicker {...inputProps} />} />
              )}
            />
            <form.Field
              name="status"
              children={(statusField) => (
                <FF
                  label="Status"
                  field={statusField}
                  input={(inputProps) => <Select data={statusOptions} {...inputProps} />}
                />
              )}
            />
          </s.RightWrapper>
        </s.Row>
      </s.FormWrapper>
    </FilterPanel>
  )
})
